export default "__VITE_ASSET__Dh49XzF7__"